// Meta Pixel tracking utilities
// Pixel ID: 1241436797968600

export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Track when someone views content (service page, etc.)
export const trackViewContent = (contentName, contentCategory, value, currency = 'AUD') => {
  trackEvent('ViewContent', {
    content_name: contentName,
    content_category: contentCategory,
    value: value,
    currency: currency
  });
};

// Track when someone initiates checkout/booking
export const trackInitiateCheckout = (value, currency = 'AUD', contentIds = [], contentType = 'service') => {
  trackEvent('InitiateCheckout', {
    value: value,
    currency: currency,
    content_ids: contentIds,
    content_type: contentType,
    num_items: contentIds.length || 1
  });
};

// Track completed purchase/booking
export const trackPurchase = (value, currency = 'AUD', contentIds = [], contentType = 'service') => {
  trackEvent('Purchase', {
    value: value,
    currency: currency,
    content_ids: contentIds,
    content_type: contentType,
    num_items: contentIds.length || 1
  });
};

// Track when someone adds to cart (selects a service)
export const trackAddToCart = (contentName, contentId, value, currency = 'AUD') => {
  trackEvent('AddToCart', {
    content_name: contentName,
    content_ids: [contentId],
    content_type: 'service',
    value: value,
    currency: currency
  });
};

// Track contact form submission
export const trackContact = () => {
  trackEvent('Contact');
};

// Track lead (membership interest, etc.)
export const trackLead = (contentName, value, currency = 'AUD') => {
  trackEvent('Lead', {
    content_name: contentName,
    value: value,
    currency: currency
  });
};

// Track membership subscription
export const trackSubscribe = (value, currency = 'AUD', predictedLtv) => {
  trackEvent('Subscribe', {
    value: value,
    currency: currency,
    predicted_ltv: predictedLtv
  });
};

export default {
  trackEvent,
  trackViewContent,
  trackInitiateCheckout,
  trackPurchase,
  trackAddToCart,
  trackContact,
  trackLead,
  trackSubscribe
};
